import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IViewFormPanelComponent} from '../../../interface/panels';
import {IFormItemsCol, IFormItemsRow} from '../../../interface/form-structure';
import * as _ from 'lodash';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {FormEventService} from '../../../services/formEventService';
import {MatRadioChange} from '@angular/material/radio';

@Component({
    selector: 'noos-form-pad',
    templateUrl: './form-pad.component.html',
    styleUrls: ['./form-pad.component.scss']
})
export class FormPadComponent implements OnInit, AfterViewInit, IViewFormPanelComponent {


    @Input()
    rows: IFormItemsRow[];

    @Input()
    datasetId: any;

    @Input()
    isFilter: boolean;

    sortedRow: IFormItemsRow[];

    @Output()
    keyOnEnter = new EventEmitter<any>();

    @Input()
    formId = 0;

    isSelectControl = false;


    constructor(private eventListenerService: FormEventService) {
    }

    ngOnInit() {

    }

    ngAfterViewInit(): void {
        this.sortedRow = _.orderBy(this.rows, ['row'], ['ASC']);

        this.isSelectControl = this.sortedRow.filter(x => x.header.create_or_select === 'select').length > 0;
    }

    _get_col_percent(col: IFormItemsCol, cols: IFormItemsCol[]) {

        if (col.fxCol !== undefined && col.fxCol !== '') {
            return col.fxCol;
        }

        const ret = (100 / cols.length);
        return ret.toString();
    }

    onEnterEvent($event: any) {
        this.keyOnEnter.emit();
    }


    onChange($event: MatRadioChange, ri: IFormItemsRow) {
        ri.header.checked = $event.value === ri.row;
        this.eventListenerService.updatedDataSelection({
            fromComponentId: ri.row,
            fromComponentName: '',
            eventName: 'select_row',
            triggerValue: ri.header.checked,
            formId: this.formId,
            datasetId: this.datasetId
        });
    }

    onSelect(ri: IFormItemsRow) {
        if (ri.header.create_or_select !== undefined && ri.header.create_or_select !== '') {
            ri.header.checked = true;
            this.eventListenerService.updatedDataSelection({
                fromComponentId: ri.row,
                fromComponentName: '',
                eventName: 'select_row',
                triggerValue: ri.header.checked,
                formId: this.formId,
                datasetId: this.datasetId
            });
        }
    }
}
